import React, {useState} from 'react';
import {Checkbox, Form, Header, Input, Segment, Tab} from 'semantic-ui-react';

function SessionConfigFields({sessionConfig, handleInputChange, propertyPath}) {
    const [config, setConfig] = useState(sessionConfig);

    const handleConfigChange = (e, {name, value, checked, type}) => {
        const newValue = type === 'checkbox' ? checked : +value;
        setConfig(prevConfig => {
            const updatedConfig = {
                ...prevConfig,
                [name]: newValue
            };
            handleInputChange(e, {name: `${propertyPath}.${name}`, value: newValue});
            return updatedConfig;
        });
    };

    return (
        <Segment>
            <Header as="h4">Sessions</Header>
            <Form.Field>
                <label>Min Players:</label>
                <Input
                    type="number"
                    name="minPlayers"
                    title="Min number of players required to start allocating a server"
                    value={config.minPlayers}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Max Players:</label>
                <Input
                    type="number"
                    name="maxPlayers"
                    title="Max number of players allowed in a session"
                    value={config.maxPlayers}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Fillup TimeOut:</label>
                <Input
                    type="number"
                    name="fillupTimeOut"
                    title="Max amount of time a session is allowed to wait during fillup for there being enough players"
                    value={config.fillupTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Allocation TimeOut:</label>
                <Input
                    type="number"
                    name="allocationTimeOut"
                    title="Max amount of time a session is allowed to wait during allocating for finding a server"
                    value={config.allocationTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Playing ClearOut:</label>
                <Input
                    title="The amount of time after which a playing session will be removed from the dashboard"
                    type="number"
                    name="playingClearOut"
                    value={config.playingClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Expired ClearOut:</label>
                <Input
                    title="The amount of time after which an expired session will be removed from the dashboard"
                    type="number"
                    name="expiredClearOut"
                    value={config.expiredClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Waiting Time Threshold:</label>
                <Input
                    title="Max waiting time before players are forefully matchmaked"
                    type="number"
                    name="waitingTimeThreshold"
                    value={config.waitingTimeThreshold}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <Checkbox toggle
                          title="isQuickJoinDisabled"
                          name="isQuickJoinDisabled"
                          label="Disable Quick Join"
                          checked={config.isQuickJoinDisabled}
                          onChange={handleConfigChange}
                />
            </Form.Field>
        </Segment>
    );
}

function ServerConfigFields({serverConfig, handleInputChange, propertyPath}) {
    const [config, setConfig] = useState(serverConfig);

    const handleConfigChange = (e, {name, value}) => {
        setConfig(prevConfig => ({
            ...prevConfig,
            [name]: +value
        }));
        handleInputChange(e, {name: `${propertyPath}.${name}`, value});
    };

    return (
        <Segment>
            <Header as="h4">Server</Header>
            <Form.Field>
                <label>Server Ready TimeOut:</label>
                <Input
                    title="Timeout after a server is ready and waiting"
                    type="number"
                    name="readyTimeOut"
                    value={config.readyTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Server Allocated TimeOut:</label>
                <Input
                    title="Timeout after a server is allocated"
                    type="number"
                    name="allocatedTimeOut"
                    value={config.allocatedTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Player Threshold:</label>
                <Input
                    title="Required player threshold to start a game"
                    type="number"
                    name="playerThreshold"
                    value={config.playerThreshold}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Server Playing ClearOut:</label>
                <Input
                    title="The amount of time after which a playing server will be removed from the dashboard"
                    type="number"
                    name="playingClearOut"
                    value={config.playingClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Server Expired ClearOut:</label>
                <Input
                    title="The amount of time after which an expired server will be removed from the dashboard"
                    type="number"
                    name="expiredClearOut"
                    value={config.expiredClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Minimum Remaining Game Time Needed</label>
                <Input
                    title="The amount of minimum game time needed before player can enter"
                    type="number"
                    name="minRemainingGameTimeNeeded"
                    value={config.minRemainingGameTimeNeeded}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Score Threshold</label>
                <Input
                    title="The score threshold after which player can not join on going game"
                    type="number"
                    name="scoreThreshold"
                    value={config.scoreThreshold}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Wait Time:</label>
                <Input
                    title="The amount of time a server will wait before starting game"
                    type="number"
                    name="waitTime"
                    value={config.waitTime}
                    onChange={handleConfigChange}
                />
            </Form.Field>
        </Segment>
    );
}


function MmrConfigFields({mmrConfig, handleInputChange, propertyPath}) {
    const [config, setConfig] = useState(mmrConfig);
    const handleConfigChange = (e, {name, value, type, checked}) => {
        setConfig(prevConfig => {
            if (type === 'checkbox' && name === 'isMmrEnabled') {
                console.log("####check: ", checked)
                return {...prevConfig, isMmrEnabled: checked};
            }
            if (name === 'controlledValue') {
                return {...prevConfig, controlledValue: parseInt(value, 10)};
            }
            if (name === 'ranges.0.min') {
                return {
                    ...prevConfig,
                    ranges: prevConfig.ranges.map((range, index) =>
                        index === 0 ? {...range, min: parseInt(value, 10)} : range)
                }
            }
            if (name === 'ranges.0.max') {
                return {
                    ...prevConfig,
                    ranges: prevConfig.ranges.map((range, index) =>
                        index === 0 ? {...range, max: parseInt(value, 10)} : range)
                }
            }
            if (name === 'ranges.1.min') {
                return {
                    ...prevConfig,
                    ranges: prevConfig.ranges.map((range, index) =>
                        index === 1 ? {...range, min: parseInt(value, 10)} : range)
                }
            }
            if (name === 'ranges.1.max') {
                return {
                    ...prevConfig,
                    ranges: prevConfig.ranges.map((range, index) =>
                        index === 1 ? {...range, max: parseInt(value, 10)} : range)
                }
            }
        });
        handleInputChange(e, {name: `${propertyPath}.${name}`, value: type === 'checkbox' ? checked : value});
    };

    return (
        <Segment>
            <Header as="h4">MMR</Header>
            <Form.Field>
                <Checkbox toggle
                          title="isMmrEnabled"
                          name="isMmrEnabled"
                          label="MMR Enable/Disable"
                          checked={config.isMmrEnabled}
                          onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Controlled Value:</label>
                <Input
                    title="Controlled value"
                    type="number"
                    name="controlledValue"
                    value={config.controlledValue}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Range 1:</label>
                <Input
                    type="number"
                    name="ranges.0.min"
                    value={config.ranges[0].min}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <Input
                    type="number"
                    name="ranges.0.max"
                    value={config.ranges[0].max}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Range 2:</label>
                <Input
                    type="number"
                    name="ranges.1.min"
                    value={config.ranges[1].min}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <Input
                    type="number"
                    name="ranges.1.max"
                    value={config.ranges[1].max}
                    onChange={handleConfigChange}
                />
            </Form.Field>
        </Segment>
    );
}

function FullConfigSegment({config, handleInputChange, propertyPath}) {
    return (
        <Tab.Pane>
            <SessionConfigFields sessionConfig={config.sessionCfg} handleInputChange={handleInputChange}
                                 propertyPath={`${propertyPath}.sessionCfg`}/>
            <ServerConfigFields serverConfig={config.serverCfg} handleInputChange={handleInputChange}
                                propertyPath={`${propertyPath}.serverCfg`}/>
            <MmrConfigFields mmrConfig={config.mmrConfig} handleInputChange={handleInputChange}
                             propertyPath={`${propertyPath}.mmrConfig`}/>
        </Tab.Pane>
    );
}

const ModeConfigWidget = ({adminCfg, handleInputChange, activeTab, handleTabChange}) => {
    const modeConfigPanes = [
        {
            menuItem: 'TDM',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.tdm.quad} handleInputChange={handleInputChange}
                                          propertyPath='tdm.quad'/>;
            },
        },
        {
            menuItem: 'MiniTDM',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.miniTDM.duo} handleInputChange={handleInputChange}
                                          propertyPath='miniTDM.duo'/>;
            },
        },
        {
            menuItem: 'LowGravity',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.lowGravity.solo}
                                          handleInputChange={handleInputChange} propertyPath='lowGravity.solo'/>;
            },
        },
        {
            menuItem: 'DeadeyeDM',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.deadeyeDM.solo}
                                          handleInputChange={handleInputChange} propertyPath='deadeyeDM.solo'/>;
            },
        },
        {
            menuItem: 'ControlPoints',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.controlPoints.quad}
                                          handleInputChange={handleInputChange} propertyPath='controlPoints.quad'/>;
            },
        },
        {
            menuItem: 'Ftue-CP',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.ftueControlPoints.quad}
                                          handleInputChange={handleInputChange} propertyPath='ftueControlPoints.quad'/>;
            },
        },
        {
            menuItem: 'GunGame',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.gunGame.solo}
                                          handleInputChange={handleInputChange} propertyPath='gunGame.solo'/>;
            },
        },
        {
            menuItem: 'Football',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.football.quad}
                                          handleInputChange={handleInputChange} propertyPath='football.quad'/>;
            },
        },
        {
            menuItem: 'VIP',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.vip.quad}
                                          handleInputChange={handleInputChange} propertyPath='vip.quad'/>;
            },
        },
        {
            menuItem: 'Showdown',
            render: () => {
                return <FullConfigSegment config={adminCfg.modeCfg.showdown.solo}
                                          handleInputChange={handleInputChange} propertyPath='showdown.solo'/>;
            },
        },
    ];

    return (
        <Tab
            panes={modeConfigPanes}
            key={activeTab}
            menu={{vertical: false, tabular: false, pointing: true}}
            activeIndex={activeTab}
            onTabChange={handleTabChange}
        />
    );
};


function BRConfigWidget({brConfig, handleInputChange, activeIndex, handleBRTabChange, propertyPath}) {
    const modeConfigPanes = [
        {
            menuItem: 'Solo',
            render: () => <FullConfigSegment config={brConfig.solo} handleInputChange={handleInputChange}
                                             propertyPath={`${propertyPath}.solo`}/>,
        },
        {
            menuItem: 'Duo',
            render: () => <FullConfigSegment config={brConfig.duo} handleInputChange={handleInputChange}
                                             propertyPath={`${propertyPath}.duo`}/>,
        },
        {
            menuItem: 'Quad',
            render: () => <FullConfigSegment config={brConfig.quad} handleInputChange={handleInputChange}
                                             propertyPath={`${propertyPath}.quad`}/>,
        },
    ];

    return (
        <Tab
            panes={modeConfigPanes}
            menu={{vertical: false, tabular: true, pointing: true}}
            key={activeIndex}
            activeIndex={activeIndex}
            onTabChange={handleBRTabChange}
        />
    );
}

export default ModeConfigWidget;